module.exports = __webpack_public_path__ + "static/media/hero.94e4181a.png";